import Grid from "@material-ui/core/Grid";
import Polygon from "./Polygon";
import Divider from "./Divider";
import React from "react";
import pentagonCyan from "../../../../assets/images/pentagonCyan.png";
import pentagonGreen from "../../../../assets/images/pentagonGreen.png";
import pentagonLightRed from "../../../../assets/images/pentagonLightRed.png";
import pentagonOrange from "../../../../assets/images/pentagonOrange.png";
import pentagonPink from "../../../../assets/images/pentagonPink.png";
import pentagonRoseGold from "../../../../assets/images/pentagonRoseGold.png";
import pentagonYellow from "../../../../assets/images/pentagonYellow.png";

class PolygonHolder extends React.Component {

    componentDidMount() {
    }
    convertor=(value,maxValue,key,pointer)=>{
        let res=0
        if (key===pointer)
            res =Math.floor((value * 100)/maxValue)
        else if(key<=pointer)
            res=100
        return res
    }
    render() {
        const {data}=this.props
        const bgConverter=(color)=>{
                switch (color) {
                    case 'yellow':
                        return pentagonYellow
                    case 'roseGold':
                        return pentagonRoseGold
                }
            }
        const key=this.props.ky
        const{originalData:{list,centerColor}}=this.props
        const {pointer,countTrue}=this.props.originalData
        const maxConditionValue=list[list.length-1].conditionValue
        const progress = this.convertor(countTrue,maxConditionValue,key,pointer)
        const badge={
        conditionValue:data.conditionValue,
        countTrue:progress,
        maxConditionValue:maxConditionValue,
        background:centerColor
    }
        const normal={
            icon:data.normalImg,
            text:data.giftValue_normal,
            textColor:'#ffffff',
            locked:false,
            polygon:bgConverter('roseGold'),
            hasGlowBackground:false,
        }
        const vip={
            icon:data.vipImg,
            text:data.giftValue_vip,
            textColor:'yellow',
            polygon:bgConverter('yellow'),
            locked:true,
            hasGlowBackground:true,
        }
    return(
        <Grid item container xs={12} alignItems={"center"} justify={"center"} sm={12}
              style={{
                  borderBottom: key !==pointer ? '1px solid rgb(216, 225, 237)' : '10px solid yellow',
                  backgroundColor: key !== pointer? 'rgba(0,0,0,0.5)' : ''
              }}
              className='gift-hall'
        >
            {key === pointer &&
                <Grid className='gift-hall-moving-light' item/>
            }
            {/*normal*/}
            <Grid sm={5} xs={5} container alignItems={"center"} justify={"center"}
                  style={{height: '200px', padding: '20px'}}
            >
                <Polygon data={normal}/>
            </Grid>
            <Grid sm={1} xs={1} container alignItems={"flex-end"} justify={"center"}
                  style={{backgroundColor: 'red', height: '100%', width: '100%'}}
            >
                <Grid container style={{width: '100%', height: '100%'}}>
                    <Divider data={badge}/>
                </Grid>
            </Grid>
            {/*golden*/}
            <Grid sm={5} xs={5} container alignItems={"center"} justify={"center"}
                  style={{height: '200px', padding: '20px'}}
            >
                <Polygon data={vip}/>
            </Grid>
        </Grid>
    )
}
}
export default PolygonHolder